import { motion } from 'framer-motion'

/**
 * Blurred-out version of the leaderboard, used as a teaser background on the
 * activation flow. Children render the unlock CTA on top.
 */
export default function LockedOverlay({ children }) {
  return (
    <div className="relative">
      <div className="absolute inset-0 backdrop-blur-md bg-white/40 z-10" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="relative z-20"
      >
        {children}
      </motion.div>
    </div>
  )
}
